<h3-objectless-view-settings-slider
  class="form-group"
  label="Opacity"
  [default]="defaultLayerOpacity"
  [setting]="eventSettingName"
  [nasModel]="layerOpacityStore"
  [disabled]="layerOpacityDisabled$ | async"
  [settingStore]="layerOpacityStore"
></h3-objectless-view-settings-slider>
